import { INCENTIVE_ID } from "../utils/constants/index";

export function getIncentiveIdFromQuery(search = window.location.search) {
  return new URLSearchParams(search).get(INCENTIVE_ID);
}

export function resolveChosenIncentiveId(userIncentiveSummary, incentiveIdFromQuery) {
  if (!userIncentiveSummary?.length) {
    return "";
  }

  if (incentiveIdFromQuery) {
    const match = userIncentiveSummary.find(
      (incentive) => incentive.incentiveId === incentiveIdFromQuery
    );
    if (match) {
      return match.incentiveId;
    }
  }

  return userIncentiveSummary[0].incentiveId;
}

export function buildPathWithQuery(path, queryParams) {
  const params = new URLSearchParams();

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value) {
      params.set(key, value);
    }
  });

  const queryString = params.toString();
  return queryString ? `${path}?${queryString}` : path;
}

export function buildPathWithIncentiveId(path, incentiveId = getIncentiveIdFromQuery()) {
  return buildPathWithQuery(path, { [INCENTIVE_ID]: incentiveId });
}

export function removeIncentiveIdFromUrl() {
  const params = new URLSearchParams(window.location.search);
  if (!params.has(INCENTIVE_ID)) {
    return;
  }

  params.delete(INCENTIVE_ID);
  const queryString = params.toString();
  const newUrl =
    window.location.origin +
    window.location.pathname +
    (queryString ? `?${queryString}` : "");

  window.history.replaceState({}, document.title, newUrl);
}
